module.exports = __webpack_public_path__ + "static/media/202A-1302A.ea8699b4.png";